export var SqlQueryExecutionStatus;
(function (SqlQueryExecutionStatus) {
    SqlQueryExecutionStatus["SQL_QUERY_EXECUTION_STATUS_QUEUED"] = "QUEUED";
    SqlQueryExecutionStatus["SQL_QUERY_EXECUTION_STATUS_RUNNING"] = "RUNNING";
    SqlQueryExecutionStatus["SQL_QUERY_EXECUTION_STATUS_SUCCEEDED"] = "SUCCEEDED";
    SqlQueryExecutionStatus["SQL_QUERY_EXECUTION_STATUS_FAILED"] = "FAILED";
    SqlQueryExecutionStatus["SQL_QUERY_EXECUTION_STATUS_CANCELLED"] = "CANCELLED";
})(SqlQueryExecutionStatus || (SqlQueryExecutionStatus = {}));
